import moment from "moment";
import axios from "./axios";

export async function getWhere(
  start = moment().subtract(1, "y").format("YYYY-MM-DD"),
  end = moment().format("YYYY-MM-DD"),
  page = 1,
  isPrint = false
) {
  return axios.get(
    `api/reports?page=${page}&date_start=${start}&date_end=${end}&print=${
      isPrint ? 1 : 0
    }&sortBy=banked_at desc`
  );
}

export const getAnnualReport = (date_start, date_end) => {
  //lets determine if is current or previous annual report:
  const endCurrentFinancialYear = moment();
  endCurrentFinancialYear.month(5);
  endCurrentFinancialYear.date(30);

  //If the start date is before the end of the last financial year or not determines if this or last financial period.
  const reportPeriod = endCurrentFinancialYear.isAfter(moment(date_start))
    ? "Prior FY"
    : "Current FY";

  //Save the Annual report request event to Google Analytics
  if (typeof window.ga !== "undefined") {
    window.ga(
      "send",
      "event",
      `${reportPeriod} support summary requested`,
      date_end
    );
  }

  var w = window.open();
  w.location = `${process.env.REACT_APP_API_URL}/api/reports?date_start=${date_start}&date_end=${date_end}&print=1`;
  w.focus();
};

export const getRecieptReport = (receipt_no) => {
  // Save the specific receipt request event to Google Analytics
  if (typeof window.ga !== "undefined") {
    window.ga("send", "event", "Receipt requested", receipt_no);
  }

  var w = window.open();
  w.location = `${process.env.REACT_APP_API_URL}/api/reports/${receipt_no}?print=1`;
  w.focus();
};

const Histrory = { getAnnualReport, getRecieptReport, getWhere };

export default Histrory;
